export default __webpack_public_path__ + "static/media/quarantine_management_preview.529e5216.svg";